export default "__VITE_ASSET__DhcVEM0i__"